var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-2.2 -2.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1106",
    "data-name": "Rectangle 1106",
    d: "M-.133-.8H6.533A.667.667,0,0,1,7.2-.133V6.533a.667.667,0,0,1-.667.667H-.133A.667.667,0,0,1-.8,6.533V-.133A.667.667,0,0,1-.133-.8Zm6,1.333H.533V5.867H5.867Z",
    transform: "translate(3 2.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    d: "M-.133-.8H6.533A.667.667,0,0,1,7.2-.133V6.533a.667.667,0,0,1-.667.667H-.133A.667.667,0,0,1-.8,6.533V-.133A.667.667,0,0,1-.133-.8Zm6,1.333H.533V5.867H5.867Z",
    transform: "translate(13 2.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    d: "M-.133-.8H6.533A.667.667,0,0,1,7.2-.133V6.533a.667.667,0,0,1-.667.667H-.133A.667.667,0,0,1-.8,6.533V-.133A.667.667,0,0,1-.133-.8Zm6,1.333H.533V5.867H5.867Z",
    transform: "translate(13 12.864)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    d: "M-.133-.8H6.533A.667.667,0,0,1,7.2-.133V6.533a.667.667,0,0,1-.667.667H-.133A.667.667,0,0,1-.8,6.533V-.133A.667.667,0,0,1-.133-.8Zm6,1.333H.533V5.867H5.867Z",
    transform: "translate(3 12.864)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridicon);
export default __webpack_public_path__ + "static/media/Gridicon.df28727e3568740dfd171654aff21244.svg";
export { ForwardRef as ReactComponent };